import React from 'react';
import cx from 'classnames';
import { string } from 'prop-types';

import { Icon } from '../';

const CLASS_ROOT = 'plate';

const propTypes = {
  disc: string,
  label: string,
  content: string,
  href: string,
};

const Plate = ({ className, style, disc, label, content, href, ...other }) => {
  const classes = cx(CLASS_ROOT, className);

  const returnLink = href ? (
    <a href={href}>
      <strong>{content}</strong>
    </a>
  ) : (
    <strong>{content}</strong>
  );

  return (
    <div className={classes} {...other}>
      <div className="plate__disc">
        <Icon name={disc} />
      </div>
      <div>
        <div>
          <h3 className="text-color-white no-mrg">{label}</h3>
        </div>
        <div>
          <h2 className=" text-color-white no-mrg">{returnLink}</h2>
        </div>
      </div>
    </div>
  );
};

Plate.propTypes = propTypes;

export default Plate;
